import React from 'react'
import {
    ArrowLeftOutlined
} from '@ant-design/icons';
import { useNavigate} from "react-router-dom";

export default function BackButton() {

    const navigate = useNavigate();

    return (
        <div>
            <div className='d-flex justify-content-start align-items-start'>
                <ArrowLeftOutlined onClick={() => navigate(-1)} />
            </div>
        </div>
    )
}